import React from 'react';
import { AlertModel, AlertType } from '../alert.model';

export const DismissableAlertContext = React.createContext<AlertModel>({
  isShown: false,
  message: 'Error',
  type: AlertType.ERROR,
});
